import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import TableC from '../../../basicElement/TableC';
import Fetch from '../../../../common/Fetch';
import API_URL from '../../../../common/url';

class Log extends Component {
    state = {
        data: [],
        record: {},
        visible: false,
        loading: false,
    }

    loadData = () => {
        // const { record: { jdeMainApplyId } } = this.state;
        // this.setState({ loading: true });
        // Fetch.post(API_URL.contract.queryJdeMainApplyApprovalHistory, {
        //     jdeMainApplyId,
        // }).then(res => {
        //     this.setState({
        //         data: res.data,
        //         loading: false,
        //     }, () => {
        //         this.loadData();
        //     });
        // }).catch(error => {
        //     console.error(error);
        //     this.setState({ loading: false });
        // });
        this.setState({ data: [
            { version: 'V2', date: '2020-01-08 09:00:00', userName: '洪有源', employeeCode: '200424', content: '合理性审批', conclusion: '审批通过', statusChange: 'BDO审批通过' },
            { version: 'V1', date: '2020-01-08 08:00:00', userName: '洪有源', employeeCode: '200424', content: '合理性审批', conclusion: '审批不通过', statusChange: 'BDO审批不通过' }
        ] });
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => ([
        {
            title: '版本',
            dataIndex: 'version',
            key: 'version',
            width: 80,
        }, {
            title: '操作时间',
            dataIndex: 'date',
            key: 'date',
            width: 85,
        }, {
            title: '操作人',
            dataIndex: 'userName',
            key: 'userName',
            width: 100,
            render: (text, record) => {
                const { employeeCode } = record;
                return `${text}[${employeeCode}]`;
            }
        }, {
            title: '操作内容',
            dataIndex: 'content',
            key: 'content',
            width: 120,
        }, {
            title: '审批结论',
            dataIndex: 'conclusion',
            key: 'conclusion',
            width: 120,
        },  {
            title: '报价单状态变化',
            dataIndex: 'statusChange',
            key: 'statusChange',
            width: 165
        }
    ])

    render() {
        const { data, visible, loading, record } = this.state;
        const { quotationNum, salesforceId } = record;
        return (
            <Modal
                title="操作日志"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="710px"
                bodyStyle={{ maxHeight: 500 }}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <div>
                    <div style={{ marginBottom: 16 }}>
                        报价单号：{quotationNum}
                        <span className="ant-divider" />
                        Salesforce ID：{salesforceId}
                    </div>
                    <TableC
                        data={data}
                        loading={loading}
                        columns={this.getColumns()}
                        className="quotationLog"
                    />
                </div>
            </Modal>
        );
    }
}

export default Log;


// WEBPACK FOOTER //
// ./src/components/quotation/list/Components/Log.js